import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=266c249e&scoped=true"
import script from "./EmailTemplates.vue?vue&type=script&lang=js"
export * from "./EmailTemplates.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplates.vue?vue&type=style&index=0&id=266c249e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266c249e",
  null
  
)

export default component.exports